import { useBreak } from "hooks/useBreak"
import { Label } from "./Overview.label"
import { _bootstrap } from "state/store.bootstrap"
import { getFocus, useAtom, useGet } from "state/jotai"
import { current_language, rotate_by_slider } from "state/store.global"
import { AnimatePresence } from "framer-motion"
import { motion } from 'framer-motion'
import { MobileLabel } from "./MobileOverview.label"
import { _project } from "state/store.projects"
import { _isometry } from "state/store.isometry"

export const Overview = ({ index, rmode, status, showLabel, setShowLabel, hoveredId }) => {

   
    const labelOptions = getFocus(_bootstrap, 'projectnames')
    const scale      = getFocus(_isometry, 'activescale');
   
    const currentLanguage = useAtom(current_language)[0];
  
    const isRotate_Done = useGet(rotate_by_slider)
    const isDesktop = useBreak('md_up')
    
    const L = [ // desktop labels position
        {L1: [808, 583] , L2: [1360, 375], L3: [225, 687], L4: [493, 710], L5: [1127, 456], L6: [862, 360], L7: [516, 460]  },
    ];

    const circle = [ // desktop circle position
        { L1: [50, 300]  , L2: [50, 300],  L3: [50, 300], L4: [50, 300], L5: [50, 300], L6: [50, 300], L7: [50, 300] },
    ]
    const mobileL = [ // mobile labels position
        { L1: [791, 586] , L2: [1378, 370], L3: [186, 690], L4: [492, 710], L5: [1111, 458], L6: [850, 342], L7: [505, 457] },
    ];

    const mobileLine = [ // mobile line lengths
        { L1: [450, 0], L2: [450, 0], L3: [450, 0], L4: [450, 0], L5: [450, 0], L6: [450, 0], L7: [450, 0] },
    ];

    const mobileLineAngle = [ // mobile line angles
        { L1: 215, L2: 215, L3: 215, L4: 215, L5: 215, L6: 215, L7: 215 },
    ];

    const mobileLabelAxis = [ // mobile label positions
        { L1:[300, 0] , L2:[300, 0], L3:[300, 0], L4:[300, 0], L5:[300, 0], L6:[300, 0], L7:[300, 0] },
    ];

    const animation = {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.1, ease: 'linear' },
    }

    // dummy property till neptus released
    const d = [
            {
            "Language": "da",
            "Presentation": "Neptunus",
            "URLSafe": "neptunus",
            "PID": "14",
            "path": "/isometry/neptunus"
        }
    ]

    return (
        <AnimatePresence>
            {
                status === 'DONE' && isRotate_Done &&
                <>
                    {
                        
                        isDesktop ?
                        labelOptions?.[currentLanguage]?.map((label, i) => {
                            if (L?.[index]?.[`L${i}`]) {
                                if (i) {
                                    return (
                                        <motion.div {...animation} key={i}>
                                            <Label setShowLabel={setShowLabel} c={L?.[index]?.[`L${i}`]} sc={scale} d={40} l={0} r={circle?.[index]?.[`L${i}`]} {...{ rmode }} labelsInfo={label} showLabel={showLabel} hoveredId={hoveredId}/>
                                            {
                                                i == 6 && <Label setShowLabel={setShowLabel} c={L?.[index]?.[`L${7}`]} sc={scale} d={40} l={0} r={circle?.[index]?.[`L${7}`]} {...{ rmode }} labelsInfo={d[0]} showLabel={showLabel} hoveredId={hoveredId}/>
                                            }
                                        </motion.div>
                                    )
                                }
                                return null;
                                }
                            })
                            :
                            labelOptions?.[currentLanguage]?.map((label, i) => {
                                if (i) {
                                    return (
                                        <motion.div {...animation} key={i}>
                                            <MobileLabel setShowLabel={setShowLabel} c={mobileL?.[index]?.[`L${i}`]} sc={scale} d={40} l={0} r={circle?.[index]?.[`L${i}`]} {...{ rmode }} labelsInfo={label} line={mobileLine?.[index]?.[`L${i}`]} angle={mobileLineAngle?.[index]?.[`L${i}`]} mobileLabelAxis={mobileLabelAxis?.[index]?.[`L${i}`]} showLabel={showLabel} hoveredId={hoveredId}/>
                                             {
                                                i == 6 &&  <MobileLabel setShowLabel={setShowLabel} c={mobileL?.[index]?.[`L${7}`]} sc={scale} d={40} l={0} r={circle?.[index]?.[`L${7}`]} {...{ rmode }} labelsInfo={d[0]} line={mobileLine?.[index]?.[`L${i}`]} angle={mobileLineAngle?.[index]?.[`L${i}`]} mobileLabelAxis={mobileLabelAxis?.[index]?.[`L${i}`]} showLabel={showLabel} hoveredId={hoveredId}/>
                                            }
                                        </motion.div>
                                    )
                                }
                                return null;
                              
                            })
                    }
                </>
            }
        </AnimatePresence>
    )
}
